export default __webpack_public_path__ + "static/media/en.59c09ec3.svg";